import { Statement } from '../types'

export const StatementData: Statement[] = [
    {
        sequence: "01",
        title: "Встреча и знакомство",
        description: "Эта встреча бесплатная. Мы встречаемся в удобном для вас месте (на объекте, кофейне). Я рассказываю, как будет строиться наша работа. Как будет выглядеть комплект документов.",
        description_full: `Эта встреча бесплатная. Мы встречаемся в удобном для вас месте (на объекте, кофейне). Я рассказываю, как будет строиться наша работа. Как будет выглядеть комплект документов.
На этой встрече я прошу вас заполнить техническое задание, подобрать референсы.
После заполнения ТЗ , подписание договора на дизайн-проект.`
    },
    {
        sequence: "02",
        title: "Выезд на объект",
        description: "Замеры объекта профессиональным оборудованием c фото и видеофиксацией.",
        description_full: `Замеры объекта проводятся профессиональным оборудованием, сопровождаются фото и видеофиксацией.
Данная работа занимает от 2-х часов в зависимости и площади и конфигурации помещения.
На данном этапе мы подписываем договор и вы вносите предопллату по договору 20% от стоимости дизайн-проекта.
На данном этапе необходимо получить у управляющей компании технические условия по квартире.
Через 3-5 рабочих дней после замеров вам направляю обмерный план .
Вы вносите  предоплату за следующий этап планировочное решение , 30% от стоимости дизайн-проекта.`
    },
    {
        sequence: "03",
        title: "Планировочное решение",
        description: "Разработка вариантов планировочного решения на основании заполненного технического задания.",
        description_full: `На данном этапе я разрабатываю три варианта планировочного решения, на основании заполненного технического задания.
После утверждения планировочного решения вы вносите предоплату за следующий этап 3D визуализация, 30%  от стоимости дизайн-проекта.`
    },
    {
        sequence: "04",
        title: "3D визуализация",
        description: "Создание изображений будущего интерьера, подборка цветового решения, декора, мебели,  освещения, напольного покрытия.",
        description_full: `После согласования планировочного решения , мы переходим к созданию коллажей.
Коллаж- это подборка изображений будущего интерьера , а именно подборка цветового решения, декора, мебели,  освещения,, напольного покрытия. Коллаж создается для всех помещений.
После утверждения коллажей создается 3D визуализация (всех помещений).
После утверждения 3D визуализации, мы переходим к следующему этапу рабочая документация. Вы вносите оплату 20% от стоимости дизайн-проекта.`
    },
    {
        sequence: "05",
        title: "Рабочая документация",
        description: "Подготовка строительнвх чертежей для начала строительно-монтажных работ.",
        description_full: `Рабочая документация – это строительные чертежи для начала строительно-монтажных работ.
После выполнения чертежей я отправляю вам на утверждение.`
    },
    {
        sequence: "06",
        title: "Сдача проекта",
        description: "Согласование документации, подготовка и передача альбома и чертежами и визуальзацией.",
        description_full: `После согласования рабочей документации, я готовлю для вас альбом с чертежами и 3d визуализацией.
В полный дизайн- проект не входит Авторский надзор. Его можно заказать отдельно.
Авторский надзор – это контроль соответствия строительных работ с проектным.
Комплектация объекта – это подбор отделочных материалов, техники, мебели, освещения и декора.`
    }
]